import React, { useEffect } from 'react';
import { SearchInput } from '@economic/taco';
import _debounce from 'lodash.debounce';
import { t } from './l10n/l10n';
import useKeyShortcut from '../hooks/useKeyShortcut';
import { SourceComponent } from '../../../types';

interface FilterInputProps {
    sourceComponent?: SourceComponent;
    filter: string;
    hideIcon?: boolean;
    onFilter: (filter: string) => void;
}

const FilterInput = ({ sourceComponent, onFilter, filter }: FilterInputProps) => {
    const [searchText, setSearchText] = React.useState(filter);
    const ref = React.useRef<HTMLInputElement>(null);

    const focus = () => ref?.current?.focus();

    useKeyShortcut('alt+s', focus);

    // TODO: This should be removed once render issues with autoFocus being overwritten is resolved (EC-36855)
    useEffect(() => {
        if (sourceComponent === SourceComponent.ComboBox) {
            setTimeout(() => {
                focus();
            });
        }
    }, []);
    // TODO: This should be removed once render issues with autoFocus being overwritten is resolved (EC-36855)

    const handleKeydown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        event.stopPropagation();
    };

    return sourceComponent === SourceComponent.ComboBox ? (
        <SearchInput
            ref={ref}
            autoFocus
            defaultValue={filter}
            placeholder={t`FORM_LISTVIEW_FILTER_PLACEHOLDER`}
            onKeyUp={_debounce(({ target: { value } }) => {
                if (value !== searchText) {
                    setSearchText(value);
                    onFilter(value);
                }
            }, 250)}
        />
    ) : (
        <SearchInput
            ref={ref}
            onBlur={event => onFilter(event.target.value)}
            onSearch={() => {
                // EC-43922 clear button will blur search input before clicking search icon
                ref.current?.focus();
                ref.current?.blur();
            }}
            placeholder={t`FORM_LISTVIEW_FILTER_PLACEHOLDER`}
            value={searchText}
            onKeyDown={handleKeydown}
            onChange={({ target: { value } }) => setSearchText(value)}
        />
    );
};

export default FilterInput;
